import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useStateContext } from "state";
import { AxiosError } from "axios";
import { useClientContext } from "clients";

const useGetQuickSightOrg = (): UseQueryResult<string, AxiosError> => {
  const clients = useClientContext();
  const state = useStateContext();

  const fetch = async () => {
    return await clients.management.getQuickSightOrganizationDashboard();
  };

  return useQuery({
    queryKey: ["quickSightDashboard"],
    enabled:
      !!state.user && !(state.user?.isAdhoc && state.user?.roles.length === 1),
    queryFn: fetch,
    select: (data) => data.embed_url,
  });
};

export default useGetQuickSightOrg;
